import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface Props {
  open: boolean;
  title: string;
  description: string;
  handleNo: () => void;
  handleYes: () => void;
}
export const ConfirmationDialog: React.FC<Props> = ({
  open,
  title,
  description,
  handleNo,
  handleYes,
}) => {
  return (
    <Dialog open={open} onClose={handleNo}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleNo}>No</Button>
        <Button onClick={handleYes} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
